module.exports = __webpack_public_path__ + "static/media/nav-arrow-down.4bc7519b.svg";